import { useDispatch, useSelector } from 'react-redux';
import { activateCart } from '../redux/slice/cartSlice';
import { RootState } from '../redux/store';

export function useActivateCart() {
  const dispatch = useDispatch();
  const isCartActivated = useSelector((state: RootState) => state.cart.isCartActivated);

  return () => {
    if (!isCartActivated) {
      dispatch(activateCart());
    }
  };
}